<template>
  <div class="part-row">
    <div class="row mt-1">
      <div class="col-md-12 table-responsive">
        <input v-model="title" class="form-control part-title" type="text" name="content_item_titles[]" />
      </div>
      <input id="delete" type="button" class="btn remove-part" value="목차 삭제" @click="emitDeleteContentItem()" />
      <input type="button" class="btn up-part" value="▲" @click="emitUpContentItem()" />
      <input type="button" class="btn down-part" value="▼" @click="emitDownContentItem()" />
    </div>

    <div class="row">
      <div class="col-md-12">
        <ckeditor v-model="description" :editor="editor" :config="editorConfig" @ready="attachInspector"></ckeditor>
      </div>
    </div>
    <hr />
  </div>
</template>

<script>
import inlineEditorConfig from '../mixins/InlineEditorConfig';
import { EventBus } from '../event-bus.js';
import helpers from '../helpers/helpers';

export default {
  mixins: [inlineEditorConfig],
  props: ['id'],
  data() {
    return {};
  },
  computed: {
    title: {
      get() {
        return this.$store.state.contentEditor.contentItems[this.id].title;
      },
      set(value) {
        this.$store.commit('updateContentItemEditorTitle', {
          editorId: this.id,
          title: value,
        });
        EventBus.$emit('setIsSavedContent', false);
      },
    },
    description: {
      get() {
        return this.$store.state.contentEditor.contentItems[this.id].description || '';
      },
      set(value) {
        this.commitUpdateContentItemEditorDescriptionDebounced(value);
        EventBus.$emit('setIsSavedContent', false);
      },
    },
  },
  methods: {
    emitDeleteContentItem() {
      this.$parent.$emit('deleteContentItem', this.id);
    },

    commitUpdateContentItemEditorDescriptionDebounced: _.debounce(function (value) {
      this.$store.commit('updateContentItemEditorDescription', {
        editorId: this.id,
        description: helpers.replaceSmartQuotes(value),
      });
    }, 100),

    emitUpContentItem() {
      this.$parent.$emit('upContentItem', this.id);
    },
    emitDownContentItem() {
      this.$parent.$emit('downContentItem', this.id);
    },
  },
};
</script>
